<div class="modal-dialog modal-dialog-centered datepic-modal">
    <div class="modal-content">
        <div class="modal-header" class="d-flex justify-content-center mt-5">
            <!-- <h1 *ngIf="this.title" class="font-15">{{title}}</h1> -->
        </div>
        <div class="row">
            <div class="col-12 d-flex justify-content-center datepic-body">
                <button class="closebtn" type="button" (click)="calenderClearEvents(pickerRef)">
                    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='currentColor'>
                        <path
                            d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z' />
                    </svg>
                </button>
                <ngx-daterangepicker-bootstrap #pickerRef [singleDatePicker]="singleDatePicker" [minDate]="showDates.minDate"
                    [drops]="dropsDown" [locale]="locale" [showCustomRangeLabel]="false" [linkedCalendars]="false"
                    [timePicker24Hour]="timePicker24Hour" [alwaysShowCalendars]="true" [showRangeLabelOnInput]="false"
                    [keepCalendarOpeningWithRange]="false" [isCustomDate]="isCustomDate" [isInvalidDate]="isInvalidDate"
                    [timePicker]="timePicker" (datesUpdated)="datesUpdatedRange($event)" [showCancel]="showCancel"
                    [showClearButton]="showClearButton" [title]="'Selecte date'" (clearClicked)="clearClicked(true)">
                </ngx-daterangepicker-bootstrap>
            </div>
        </div>
    </div>
</div>